import React, { useState, useEffect } from "react";
import OurGalleryComponents from "components/ImageComponents/OurGalleryComponents";
import FetchApiMethod from "Helpers/FetchApiMethod";

const OurGallery = () => {
  const [photos, setPhotos] = useState([]);

  const getAllPhotos = async () => {
    try {
      const getRecentPhotosApiResult = await FetchApiMethod(
        "ICAIstudentgallery?postman=Y",
        "POST"
      );
      setPhotos(getRecentPhotosApiResult.data || []);
    } catch (error) {
      console.error("Error fetching photos:", error);
    }
  };

  useEffect(() => {
    getAllPhotos();
  }, []);

  console.log(photos, 'line no 36');
  
  return (
    <div>
      <OurGalleryComponents photosData={photos} />
    </div>
  );
};

export default OurGallery;
